import kebabCase from 'lodash-es/kebabCase';
import { ForbiddenUploadFileTypes } from '@/models/common.models';

function parseXmlToJson(xml: string): Record<string, unknown> {
  const json: Record<string, unknown> = {};
  for (const res of xml.matchAll(
    /(?:<(\w*)(?:\s[^>]*)*>)((?:(?!<\1).)*)(?:<\/\1>)|<(\w*)(?:\s*)*\/>/gm
  )) {
    const key = res[1] || res[3];
    const value = res[2] && parseXmlToJson(res[2]);
    json[key] = (value && Object.keys(value).length ? value : res[2]) || null;
  }
  return json;
}
export class UploadService {
  async uploadFile(
    url: string,
    fields: { [key: string]: string },
    file: File,
    importer = false
  ): Promise<string> {
    const fileType = file.type;
    if (
      Object.values(ForbiddenUploadFileTypes).includes(
        fileType as ForbiddenUploadFileTypes
      )
    ) {
      throw new Error('Invalid file type');
    }

    const formData = new FormData();
    formData.append('Content-Type', file.type);
    Object.entries(fields).forEach(([k, v]) => {
      formData.append(kebabCase(k), v);
    });
    formData.append('file', file); // must be the last one

    const result = await fetch(url, {
      method: 'POST',
      body: formData,
    });

    if (!result.ok) {
      const error = parseXmlToJson(await result.text());
      const errorData = error as { Error?: { Code?: string } };
      if (errorData.Error?.Code === 'EntityTooLarge') {
        throw new Error(
          'File is too large or it exceeds your organization limit'
        );
      } else {
        throw new Error(`Error uploading file: ${result.statusText}`);
      }
    }
    // replace the S3 path with the cloudfront path
    let rootDomain = import.meta.env.VITE_MEDIA_ROOT;
    if (importer) {
      rootDomain = import.meta.env.VITE_IMPORTER_ROOT;
    }
    return `${rootDomain}/${fields['key']}`;
  }
}
